import React, { useMemo } from 'react';
import CustomButton from '../../../features/customButton/ui/main/CustomButton';
import { safeHTML } from '../../../../utils/safeHTML';
import { useTranslation } from '../../../../translations';
import { useFeatureToggle } from '../../../../hooks/useFeatureToggle';

export default function SetsPrize({
  image,
  name,
  activeTab,
  boxText,
  cost,
  day_limit: allCount,
  bought,
  button,
  boxTitle,
  limit: leftCount,
  callback,
  isEnoughCahs,
}) {
  const { t } = useTranslation();
  const gameTamagotchiBeauties = useFeatureToggle('gameTamagotchiBeauties');

  const boxType = activeTab === 0 ? 'standard' : 'rare';

  const isDontUseBox = !bought && !leftCount;

  const titleValue = bought ? boxTitle.bought(bought, boxType, t) : boxTitle.buy(leftCount, t);

  const textValue = isDontUseBox
    ? boxText.disabled(boxType, t)
    : !bought && boxText.enabled(allCount, boxType, t, gameTamagotchiBeauties);

  const isButtonDisabled = isDontUseBox ? isDontUseBox : !bought && !isEnoughCahs;

  return (
    <div className={`sets__prize`}>
      <div className={`sets__prize-bg bg-circle`} />

      {name && <h3 className={'sets__prize-name'}>{safeHTML(t(name))}</h3>}

      {titleValue && <h4 className={'sets__prize-title'}>{safeHTML(t(titleValue))}</h4>}

      {image && (
        <div className={`sets__prize-image`}>
          <img src={image} className={`sets__prize-image-img`} alt={'set'} />
        </div>
      )}

      {textValue && <div className={'sets__prize-text'}>{safeHTML(t(textValue))}</div>}

      <CustomButton disabled={isButtonDisabled} {...button.attr} count={!bought && cost} onClick={callback} />
    </div>
  );
}
